import * as React from 'react';

import Page from 'components/page/Page';
import BrandEditProfile from '../components/BrandEditProfile';

import { t } from 'utils/language';

import type { Params } from 'types';

type Props = {
  params: Params
};

const BrandEditProfileAdminPage = (
  {
    params
  }: Props
): JSX.Element => (
  <Page
    documentTitle={t('edit_profile_page')}
    customStyle={{ width: 834, margin: '20px auto 0' }}
  >
    <BrandEditProfile
      profileId={Number(params.id)}
      isSpecialtyAdminPage
    />
  </Page>
);

export default BrandEditProfileAdminPage;
